import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  approvedByContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  approvedByEmail: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  moreChip: {
    flexShrink: 0,
    backgroundColor: theme.palette.secondary.superLight,
    color: theme.palette.secondary.dark,
  },
}))

export default useStyles
